function removeHtmlTags(str) {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
}
function countWords(str) {
    return str.trim().split(/\s+/).filter(word => word.length > 0).length;
}

const countWordsHTML = (html) => {
    if(!html) return;
    return countWords(removeHtmlTags(html));
}

export default countWordsHTML